import * as T from '@/types'
import store from '@/store/store'

////////////////////////////////////////////////////////////////
// getters
////////////////////////////////////////////////////////////////

export function getTagValue (tag: T.Tag | null) {
    return tag && tag.id
}

export function getTagName (tag: T.Tag | null) {
    return tag && tag.tag
}

export function getTagColor (tag: T.Tag | null) {
    if (!tag) return '#fff'

    const storedTag = store.getters['tags/get'](tag.id)
    const storedColor = storedTag && storedTag.color
    
    return tag.color || storedColor || getRandomTagColor() || '#fff'
}

export function getRandomTagColor () {
    const colors = [
        '#17809E',
        '#366477',
        '#7D6EA6',
        '#976696',
        '#7D7932',
        '#B15858',
        '#647F41',
        '#438449',
        '#5B5B5B',
        '#986F33',
    ]
    return colors[Math.floor(Math.random() * colors.length - 1)]
}

export function getTagFilterString (tag: T.Tag | null) {
    return `${getTagName(tag)}`
}
